import axios from 'axios';

export const CalendarService = {
  async getCalendar(page, perPage = 10) {
    const res = await axios.get('calendar/', {
      params: {
        page,
        size: perPage,
      },
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
  async createCalendar(data) {
    const res = await axios.post('calendar/', data);

    if (res.status === 201) {
      return true;
    }

    return Promise.reject();
  },
  async deleteCalendar(id) {
    const res = await axios.delete(`calendar/${id}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
  async updateCalendar(data, id) {
    const res = await axios.put(`calendar/${id}/`, data);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
};
